import { useTranslation } from 'react-i18next'

import { UserProgress as UserProgressType } from 'graphqlAPI'
import { Progress } from 'components/monitoring/components'
import ProgressPopover from 'components/monitoring/components/ProgressPopover'
import { getProgressPercentage } from '../../../../../utils'
import { prefixTable } from '../constants'
import styles from './UserProgress.module.scss'

const prefixColumns = `${prefixTable}.columns`

export const UserProgress: React.FC<{
  progress: UserProgressType
  id: string
}> = ({ progress, id }) => {
  const { finish, inProgress, pending } = getProgressPercentage([progress])
  const { t } = useTranslation()
  return (
    <ProgressPopover id={id} progress={progress}>
      <Progress
        className={styles.root}
        classes={{
          finish: styles.finish,
          inProgress: styles.inProgress,
          pending: styles.pending,
        }}
        finish={finish}
        inProgress={inProgress}
        pending={pending}
      />
      {t(`${prefixColumns}.progress`, {
        count: finish,
      })}
    </ProgressPopover>
  )
}

export default UserProgress
